// extracted by mini-css-extract-plugin
module.exports = {"message":"LoadingMessageItem_message__16EBt","loading":"LoadingMessageItem_loading__uQ9Mt","ani":"LoadingMessageItem_ani__hQov8"};